import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import MatchCardListContainer from './MatchCardListContainer'
import axios from 'axios'
import key from '../../key'
import { useCookies } from 'react-cookie'
import { PulseLoader } from 'react-spinners'


function NearMe() {
    const { user } = useSelector(state => state.user)
    //eslint-disable-next-line
    const [cookies, setCookie] = useCookies(['x-auth-token'])
    const [matches, setMatches] = useState()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const fetchMatches = async () => {
            setLoading(true)
            try {
                const response = await axios.get(`${key}/api/user/matches-nearme`, { headers: { 'x-auth-token': cookies['x-auth-token'] } })
                setMatches(response.data.matchedUsers)
                setLoading(false)
            } catch (error) {
                console.log(error)
            }
        }

        fetchMatches()
        //eslint-disable-next-line
    }, [])

    return (<>
        {loading ? <div className="loading-spinner"><PulseLoader color={"#fa585b"} size={30} /></div> :
        <div className='nearMeCards'>
            <MatchCardListContainer user={user} matches={matches} title={"Members near you that match your Partner Preferences"} />
        </div>}
    </>
    )
}

export default NearMe